import React from 'react';
import {boundMethod} from "autobind-decorator";
import PropTypes from 'prop-types';
import typeUtils from '@legacy/helpers/utils/typeUtils.js.es6';
import uiUtils from '@legacy/helpers/utils/uiUtils.js.es6';
import { tints } from '@legacy/helpers/vst-colors.js.es6';
import constants from '@legacy/helpers/constants.js.es6';

const InfoIcon = class InfoIcon extends React.Component {

    static propTypes = {
        className: PropTypes.string,
        fill: PropTypes.string,
        preserveAspectRatio: PropTypes.string
    };

    static defaultProps = {
        fill: '#ffffff'
    };

    @boundMethod
    _getTitle(){
        const { title } = this.props;
        return typeUtils.isString(title) ? (
            <title>{ title }</title>
        ) : null;
    }

    render(){
        let { use, className, fill, bgFill, preserveAspectRatio } = this.props;
        let { mergeClassNames } = uiUtils,
            { icon } = constants,
            _preserveRatio = {};

        if(typeUtils.isString(preserveAspectRatio)){
            _preserveRatio['preserveAspectRatio'] = preserveAspectRatio;
        }

        if(!typeUtils.isString(bgFill)){
            bgFill = tints.CLOUD_4;
        }

        switch(use){
            case icon.ALERT:
                return (
                    <svg className={ mergeClassNames(['bl-icon--alert'], className) }
                         width="25"
                         height="23"
                         viewBox="0 0 25 23"
                         xmlns="http://www.w3.org/2000/svg"
                         { ..._preserveRatio }>
                        { this._getTitle() }
                        <g fill={ fill }>
                            <path d="M24.4184 18.357L15.1928 1.9287c-1.4567-2.5715-3.8152-2.5715-5.2718 0L.626 18.357C-.8307 20.9287.3485 23 3.1925 23h18.59c2.844 0 4.0232-2.143 2.636-4.643zm-11.7922 1.7144c-.9017 0-1.5954-.7143-1.5954-1.6428 0-.9286.6937-1.643 1.5954-1.643.9018 0 1.5954.7144 1.5954 1.643 0 .9285-.6936 1.6428-1.5954 1.6428zm1.11-4.2857H11.447l-.763-9.5h3.815l-.763 9.5z"
                                  fillRule="evenodd"
                                  id="Alert_Icon" />
                        </g>
                    </svg>
                );

            case icon.ARROW_UP:
                return (
                    <svg width="5"
                         height="9"
                         viewBox="0 0 5 9"
                         xmlns="http://www.w3.org/2000/svg"
                         { ..._preserveRatio }>
                        { this._getTitle() }
                        <g fill={ fill } fillRule="evenodd">
                            <path d="M3.535156 4.28125V8.5625H1.767578V4.28125H0L2.651367 0l2.651367 4.28125" />
                        </g>
                    </svg>
                );

            case icon.BEAKER:
              return (
                  <svg className={ mergeClassNames(['bl-icon--beaker'], className) }
                        width="448"
                        height="512"
                        viewBox="0 0 448 512"
                        xmlns="http://www.w3.org/2000/svg"
                        { ..._preserveRatio }>
                      { this._getTitle() }
                      <g fill={ fill } fillRule="evenodd">
                          <path d="M437.2 403.5L319.1 215L319.1 64h7.1c13.25 0 23.1-10.75 23.1-24l-.0002-16c0-13.25-10.75-24-23.1-24H120C106.8 0 96.01 10.75 96.01 24l-.0002 16c0 13.25 10.75 24 23.1 24h7.1L128 215l-117.2 188.5C-18.48 450.6 15.27 512 70.89 512h306.2C432.7 512 466.5 450.5 437.2 403.5zM137.1 320l48.15-77.63C189.8 237.3 191.9 230.8 191.9 224l.0651-160h63.99l-.06 160c0 6.875 2.25 13.25 5.875 18.38L309.9 320H137.1z"/>
                      </g>
                  </svg>
              );

            case icon.BELL:
                return (
                    <svg className={ mergeClassNames(['bl-icon--bell'], className) }
                         width="20"
                         height="23"
                         viewBox="0 0 20 23"
                         xmlns="http://www.w3.org/2000/svg"
                         { ..._preserveRatio }>
                        { this._getTitle() }
                        <g fill={ fill } fillRule="evenodd">
                            <path id="Bell_Icon" d="M19.37235 16.34396c-.99343-.99342-2.22724-2.22978-2.22724-7.05708 0-3.54482-2.58207-6.48604-5.96785-7.04687a1.42183 1.42183 0 0 0 .25285-.81126C11.4301.63968 10.79043 0 10.00136 0 9.21229 0 8.5726.63968 8.5726 1.42875c0 .30138.09354.58079.25284.81126-3.38578.56083-5.96784 3.50205-5.96784 7.04687 0 4.8273-1.23422 6.06366-2.22765 7.05708-1.3461 1.3461-.3921 3.65854 1.51542 3.65854h4.99848c0 1.57814 1.27935 2.8575 2.8575 2.8575 1.57814 0 2.8575-1.27936 2.8575-2.8575h4.99808c1.90372 0 2.86424-2.3097 1.51541-3.65854zm-9.371 4.7301c.19728 0 .3572.15992.3572.3572 0 .19726-.15992.35718-.3572.35718-.98476 0-1.78593-.80117-1.78593-1.78594h.71438c0 .59088.48068 1.07156 1.07156 1.07156z" />
                        </g>
                    </svg>
                );

            case icon.BELL_SLASH:
                return (
                    <svg className={ mergeClassNames(['bl-icon--bell-slash'], className) }
                         width="26"
                         height="23"
                         viewBox="0 0 26 23"
                         xmlns="http://www.w3.org/2000/svg"
                         { ..._preserveRatio }>
                        { this._getTitle() }
                        <g fill={ fill } fillRule="evenodd">
                            <path id="Bell_Slash_Icon" d="M5.0335 20.125h5.02909c0 1.5878 1.28719 2.875 2.875 2.875 1.5878 0 2.875-1.2872 2.875-2.875h1.46827L5.74326 9.94475c-.09874 4.36092-1.27753 5.54237-2.23446 6.4993-1.35435 1.35434-.3945 3.68093 1.5247 3.68093zm6.82596 0c0 .5945.48363 1.07812 1.07813 1.07812.19848 0 .35937.1609.35937.35937 0 .19848-.1609.35938-.35937.35938-.9908 0-1.79688-.80608-1.79688-1.79688h.71875zm13.25797 2.50749c-.40048.44976-1.09308.49266-1.54697.09582L.37096 2.44343c-.45388-.39688-.49714-1.0832-.09667-1.533L.7577.36751c.40053-.44976 1.09314-.49266 1.54703-.09578L7.41727 4.742c1.0789-1.29276 2.60305-2.201 4.33721-2.48823a1.43076 1.43076 0 0 1-.2544-.81627c0-.7939.6436-1.4375 1.4375-1.4375.79391 0 1.4375.6436 1.4375 1.4375 0 .30322-.0941.58434-.25439.81623 3.40652.56426 6.0044 3.5235 6.0044 7.09002 0 4.85686 1.24137 6.1008 2.24088 7.1003.54575.54576.71529 1.24775.5988 1.89216l2.53944 2.22035c.45389.39688.49715 1.0832.09667 1.533l-.48345.54293z"/>
                        </g>
                    </svg>
                );

            case icon.BOOKSHELF:
                return (
                    <svg className={ mergeClassNames(['bl-icon--bookshelf'], className) }
                         width="77"
                         height="108"
                         viewBox="0 0 77 108"
                         xmlns="http://www.w3.org/2000/svg"
                         { ..._preserveRatio }>
                        { this._getTitle() }
                        <g fill={ fill } fillRule="evenodd">
                            <path d="M42 37V27L22 37v40h30V37H42zm-5.2 19.6c0 .5-.3.7-.7.3L34 54.5c-.4-.4-1-.4-1.4 0l-2.1 2.3c-.4.4-.7.3-.7-.3V37h7v19.6z"
                                  id="Bookshelf_Icon"
                            />
                        </g>
                    </svg>
                );

            case icon.BOOK_COVER:
                return (
                    <svg className={ mergeClassNames(['bl-icon--book-cover'], className) }
                         width="150"
                         height="187"
                         viewBox="0 0 150 187"
                         xmlns="http://www.w3.org/2000/svg"
                         { ..._preserveRatio }>
                        { this._getTitle() }
                        <rect id="Rectangle-path" fill="#3C3C3C" x="0" y="0" width="150" height="199.951172" />
                        <polygon id="Shape" fill="#525252" points="75.0439453 110.024414 0 94.4091796 0 125.639648" />
                        <polygon id="Shape" fill="#646464" points="75.0439453 110.024414 0 125.639648 0 137.915039 75.1171875 153.544922 150 137.973632 150 125.610352 150 94.4238278" />
                        <polygon id="Shape" fill="#949494" points="150 169.130859 150 137.973632 75.1171875 153.544922" />
                        <polygon id="Shape" fill="#B3B3B3" points="75.1171875 153.544922 0 137.915039 0 169.174805 0 199.951172 150 199.951172 150 169.130859" />
                    </svg>
                );

            case icon.CHECKMARK:
                return (
                    <svg className={ mergeClassNames(['bl-icon--checkmark'], className) }
                         width="24"
                         height="24"
                         viewBox="0 0 24 24"
                         xmlns="http://www.w3.org/2000/svg"
                         { ..._preserveRatio }>
                        { this._getTitle() }
                        <g fill={ fill } fillRule="evenodd">
                            <path d="M20.285 2l-11.285 11.567-5.286-5.011-3.714 3.716 9 8.728 15-15.285z"/>
                        </g>
                    </svg>
                );

            case icon.CHILD:
                return (
                    <svg className={ mergeClassNames(['bl-icon--child'], className) }
                         width="12"
                         height="11"
                         viewBox="0 0 12 11"
                         { ..._preserveRatio }>
                        { this._getTitle() }
                        <g fill={ fill }>
                            <g id="Child_Icon" fillRule="evenodd">
                                <path d="M7.205 6.7903c.4047-.4046.6938-1.0404.9828-1.8497.1734-.4624.1734-.8092.1734-1.3873 0-.4046.0578-1.0404 0-1.3873C8.0144.9522 7.2052.6632 6.1646.6632 5.182.6632 4.315 1.01 3.968 2.166c-.1155.347 0 .9827 0 1.3873 0 .5203-.0577.925.1735 1.3873.289.7515.578 1.445.9827 1.8497-1.503.289-2.5434 1.0405-3.237 1.3873C.4422 8.8134.4422 9.507.4422 9.507v1.1562H11.945v-1.156c-.0578 0-.0578-.6938-1.503-1.3296-.6935-.289-1.734-1.0983-3.237-1.3873z" />
                            </g>
                        </g>
                    </svg>
                );

            case icon.CIRCLE_CHECK:
                return (
                    <svg className={ mergeClassNames(['bl-icon--circle-check'], className) }
                         width="20"
                         height="20"
                         viewBox="0 0 20 20"
                         xmlns="http://www.w3.org/2000/svg"
                         { ..._preserveRatio }>
                        { this._getTitle() }
                        <path fill={ fill } id="CircleCheck_Icon" d="M9.936.064C4.506.064.064 4.506.064 9.936s4.442 9.87 9.872 9.87 9.87-4.44 9.87-9.87c0-5.43-4.44-9.872-9.87-9.872zm6.306 7.294l-6.91 6.965c-.22.22-.603.384-.877.384h-.603c-.274 0-.658-.165-.878-.384l-3.29-3.29c-.22-.22-.22-.55 0-.713l1.26-1.262c.22-.22.55-.22.714 0l2.084 2.084c.22.22.548.22.713 0l5.703-5.703c.22-.22.55-.22.713 0l1.265 1.26c.274.11.274.44.11.656z" fillRule="evenodd"/>
                    </svg>
                );

            case icon.CIRCLE_CHECK_OPEN:
                return (
                    <svg className={ mergeClassNames(['bl-icon--circle-check-open'], className) }
                         width="20"
                         height="20"
                         viewBox="0 0 20 20"
                         xmlns="http://www.w3.org/2000/svg"
                         { ..._preserveRatio }>
                        { this._getTitle() }
                        <text style={{
                                textAlign : "start",
                                lineHeight : "125%"
                            }} x="23.873804" y="1030.8871" transform="matrix(1.00163 0 0 .99838 0 -1032.362)" fontSize="12.98912" fontWeight="bold" letterSpacing="0" wordSpacing="0" fill={ fill } stroke={ fill } strokeWidth=".498257" fontFamily="Droid Serif">
                            <tspan x="23.873804" y="1030.8871">W</tspan>
                        </text>
                        <path d="M10.032464.3269C4.70164.3269.32668 4.6534.32668 9.9841c0 5.3309 4.37496 9.7058 9.705784 9.7058s9.657257-4.3749 9.657257-9.7058c0-5.3307-4.32643-9.6572-9.65725-9.6572zm0 2.2323c4.128063 0 7.424926 3.2969 7.424926 7.4249 0 4.1282-3.296863 7.4735-7.424926 7.4735-4.128062 0-7.473454-3.3453-7.473454-7.4735 0-4.128 3.345392-7.4249 7.473454-7.4249z" fill={ fill } overflow="visible" fontFamily="Sans"/>
                        <path d="M5.187542 9.9977l3.3984 3.3983 6.28276-6.2827" fill="none" stroke={ fill } strokeWidth="2.329388"/>
                    </svg>
                );

            case icon.CIRCLE_EXCLAMATION:
                return (
                    <svg className={ mergeClassNames(['bl-icon--circle-exclamation'], className) }
                         width="72"
                         height="70"
                         viewBox="0 0 72 70"
                         xmlns="http://www.w3.org/2000/svg"
                         { ..._preserveRatio }>
                        { this._getTitle() }
                        <g transform="translate(4 3)" fill="none">
                            <circle stroke={ fill } strokeWidth="4" cx="32" cy="32" r="32"/>
                            <path d="M27.449438 43.62857h9.101124V53h-9.101124v-9.37143zM27 13.17143V12h10v1.17143L34.35955 39.06h-4.7191L27 13.17143z" fill={ fill } />
                        </g>
                    </svg>
                );

            case icon.CIRCLE_INFO:

                return (
                    <svg className={ mergeClassNames(['bl-icon--circle-info'], className) }
                         width="36"
                         height="36"
                         viewBox="0 0 36 36"
                         xmlns="http://www.w3.org/2000/svg"
                         { ..._preserveRatio }>
                        { this._getTitle() }
                        <path fill={ fill }
                              d="M30.89334 17.99992c0 7.12555-5.76663 12.89327-12.89342 12.89327-7.12547 0-12.8931-5.7665-12.8931-12.8933 0-7.12547 5.76647-12.8931 12.8931-12.8931 7.12547 0 12.89342 5.7663 12.89342 12.8931zM17.99992 2C9.16345 2 2 9.16337 2 17.99992 2 26.83655 9.16345 34 17.99992 34c8.83663 0 16.00024-7.16345 16.00024-16.00008C34.00016 9.16337 26.83663 2 17.99992 2zm2.31644 24.66544h-4.47738V16.02717h4.47738v10.63827zm-2.2386-12.83882c-1.36095 0-2.4644-1.10338-2.4644-2.46448 0-1.36094 1.10337-2.4644 2.4644-2.4644 1.36108 0 2.4643 1.1034 2.4643 2.4644 0 1.3611-1.10322 2.46448-2.4643 2.46448z"
                        />
                    </svg>
                );

            case icon.COLLEGE:
                return (
                        <svg className={ mergeClassNames(['bl-icon--college'], className) }
                             width="18"
                             height="17"
                             viewBox="0 0 18 17"
                             xmlns="http://www.w3.org/2000/svg"
                             { ..._preserveRatio }>
                            { this._getTitle() }
                            <g fillRule="evenodd" fill={ fill }>
                                <path d="M16.3636364 4.7454545L9.490909 1.309091c-.1636363 0-.1636363-.1636365-.3272726-.1636365-.1636364 0-.1636364 0-.3272728.1636364L1.9636364 4.7454542c-.3272728.1636364-.490909.3272728-.490909.6545455v1.309091h15.381818V5.4c-.1636363-.3272727-.1636363-.490909-.490909-.6545455zm.981818 11.1272728H.818182c0-.6545455.490909-1.1454546 1.1454546-1.1454546h14.0727272c.818182 0 1.309091.490909 1.309091 1.1454546zm-14.890909-8.509091H4.090909v6.5454546H2.4545454zm3.7636364 0h1.6363636v6.5454546H6.2181818zm3.6 0h1.6363636v6.5454546H9.8181818zm4.0909092 0h1.6363635v6.5454546H13.909091z"/>
                            </g>
                        </svg>
                    );

            case icon.CIRCLE_PLUS:
                return (
                    <svg className={ mergeClassNames(['bl-icon--circle-plus-add'], className) }
                         width="34"
                         height="34"
                         viewBox="0 0 34 34"
                         xmlns="http://www.w3.org/2000/svg"
                         { ..._preserveRatio }>
                        { this._getTitle() }
                        <g transform="translate(1 1)" fill="none">
                            <circle fill={ bgFill } cx="16" cy="16" r="16"/>
                            <path d="M22.825 14.775h-5.6v-5.6c0-.105-.07-.175-.175-.175h-2.1c-.105 0-.175.07-.175.175v5.6h-5.6c-.105 0-.175.07-.175.175v2.1c0 .105.07.175.175.175h5.6v5.6c0 .105.07.175.175.175h2.1c.105 0 .175-.07.175-.175v-5.6h5.6c.105 0 .175-.07.175-.175v-2.1c0-.105-.07-.175-.175-.175z"
                                  fill={ fill }
                            />
                        </g>
                    </svg>
                );

            case icon.COMMENT:
                return (
                    <svg className={ mergeClassNames(['bl-icon--comment'], className) }
                         width="54"
                         height="48"
                         viewBox="0 0 54 48"
                         xmlns="http://www.w3.org/2000/svg"
                         { ..._preserveRatio }>
                        { this._getTitle() }
                        <g fill={ fill }>
                            <g id="Comment_Icon">
                                <path d="M50.6.8H3.4C2 .8.9 1.9.9 3.3v33c0 1.4 1.1 2.5 2.5 2.5h5v5.8c0 .9.5 1.8 1.4 2.2.4.2.7.3 1.1.3.5 0 1.1-.2 1.5-.5L23 38.8h27.6c1.4 0 2.5-1.1 2.5-2.5v-33C53.1 2 51.9.8 50.6.8zm-2.5 33H22.2c-.5 0-1.1.2-1.5.5l-7.2 5.4v-3.4c0-1.4-1.1-2.5-2.5-2.5H6v-28h42.1v28z" fillRule="evenodd"/>
                            </g>
                        </g>
                    </svg>
                );

            case icon.COMPANY:
                return (
                    <svg className={ mergeClassNames(['bl-icon--company'], className) }
                         width="54"
                         height="49"
                         viewBox="0 0 54 49"
                         xmlns="http://www.w3.org/2000/svg"
                         { ..._preserveRatio }>
                        { this._getTitle() }
                        <g fill={ fill } fillRule="evenodd">
                            <path d="M22.5 33.2h8.8V44H49V6.9h-5.6V2H10.6v4.9H4.9V44h17.5V33.2zm12.9-21.1h8.4v5.6h-8.4v-5.6zm0 10.5h8.4v5.6h-8.4v-5.6zm0 10.6h8.4v5.6h-8.4v-5.6zM22.5 12.1h8.8v5.6h-8.8v-5.6zm0 10.5h8.8v5.6h-8.8v-5.6zm-4.3 16.2H9.9v-5.6h8.4v5.6zm0-10.6H9.9v-5.6h8.4v5.6zm0-10.4H9.9v-5.6h8.4v5.6z"
                                  id="Company_Icon" />
                        </g>
                    </svg>
                );

            case icon.COURSES:
                return (
                    <svg className={ mergeClassNames(['bl-icon--courses'], className) }
                         width="19"
                         height="15"
                         viewBox="0 0 19 15"
                         xmlns="http://www.w3.org/2000/svg"
                         { ..._preserveRatio }>
                        { this._getTitle() }
                        <g fill={ fill }>
                            <path d="M9.339.077c-.1746 0-.3493.0343-.483.103L.483 4.474 0 4.7216l.483.248 8.373 4.294c.2675.137.6984.137.966 0l8.212-4.2116v7.016c-.199.1327-.3218.3775-.322.6426 0 .2652.1228.5102.322.6428l-.2416 1.215h1.127l-.2414-1.2152c.199-.1326.3217-.3775.322-.6426-.0004-.2652-.123-.51-.322-.6427V4.7217h-.0005.0005l-.483-.2476L9.822.1802c-.1338-.0687-.3084-.103-.483-.103V.0768zM4.435 7.7824v2.9496c1.649 3.2954 7.918 3.7794 9.8078.0022V7.7824l-4.4835 2.2993c-.2328.1194-.6078.1194-.8406 0L4.435 7.7824z"
                                  fillRule="evenodd"
                                  id="Courses_Icon" />
                        </g>
                    </svg>
                );

            case icon.DENIED:
                return (
                    <svg className={ mergeClassNames(['bl-icon--denied'], className) }
                         width="36"
                         height="36"
                         viewBox="0 0 36 36"
                         xmlns="http://www.w3.org/2000/svg"
                         { ..._preserveRatio }>
                        { this._getTitle() }
                        <g fillRule="evenodd"
                           id="Denied_Icon">
                            <path d="M18 3C9.71 3 3 9.71 3 18s6.71 15 15 15 15-6.71 15-15S26.29 3 18 3zm7.5 20.38l-2.12 2.12L18 20.12l-5.38 5.38-2.12-2.12L15.88 18l-5.38-5.38 2.12-2.12L18 15.88l5.38-5.38 2.12 2.12L20.12 18l5.38 5.38z" fill={ fill } />
                            <path d="M0 0h36v36H0z" fill="none" />
                        </g>
                    </svg>
                );

            case icon.ENVELOPE:
                return (
                    <svg className={ mergeClassNames(['bl-icon--envelope'], className) }
                         width="37"
                         height="30"
                         viewBox="2 1 37 30"
                         xmlns="http://www.w3.org/2000/svg"
                         { ..._preserveRatio }>
                        { this._getTitle() }
                        <g fillRule="evenodd"
                           id="Envelope_Icon">
                            <path fill={ fill }
                                  d="M37.9874 11.12157v15.942c0 .88344-.31455 1.6397-.94366 2.26882-.6291.6291-1.3854.9436-2.26882.9436H5.21998c-.88344 0-1.6397-.3146-2.26882-.9437-.62912-.6291-.94367-1.3854-.94367-2.2689v-15.942c.5889.6559 1.2649 1.2381 2.0278 1.7468 4.8455 3.2928 8.1718 5.6018 9.9788 6.9269.763.5622 1.382 1.0005 1.8572 1.3151.4751.3145 1.1076.6358 1.8973.9637.7897.32795 1.5259.4919 2.2086.4919h.0401c.6826 0 1.4188-.16395 2.20852-.4919.78974-.3279 1.4222-.6492 1.8974-.96374.47516-.31456 1.09424-.75293 1.8572-1.3151 2.2755-1.6464 5.60847-3.9554 9.9989-6.92695.76296-.52204 1.43223-1.1043 2.0078-1.7468zm0-5.90295c0 1.05744-.32793 2.06804-.98382 3.0318-.65588.96374-1.4724 1.78694-2.44952 2.4696-5.0329 3.49358-8.1651 5.6687-9.39655 6.52537-.1338.0937-.4182.2978-.8533.6123-.435.3145-.7964.5689-1.0842.7629-.2878.1941-.6358.4116-1.044.6525-.4082.2409-.7931.4216-1.1545.5421-.3614.1204-.696.1807-1.0039.1807h-.0401c-.3078 0-.6425-.0603-1.0039-.1807-.3614-.1205-.7462-.3012-1.1545-.5421-.4082-.241-.7562-.4585-1.044-.6526-.2878-.1941-.6492-.4484-1.0842-.76298-.435-.31456-.7194-.51868-.8533-.61238-1.218-.8567-2.9715-2.0781-5.2604-3.66428s-3.661-2.53976-4.1161-2.861c-.8299-.5622-1.61293-1.3352-2.34913-2.319-.7362-.98386-1.1043-1.8974-1.1043-2.7407 0-1.04404.27776-1.9141.83326-2.61013.5555-.6961 1.3486-1.0441 2.3793-1.0441H34.775c.87004 0 1.62296.3145 2.25877.9436.6358.6291.9537 1.3854.9537 2.2688z"
                            />
                        </g>
                    </svg>

            );

            case icon.LOADER: {
                return (
                    <svg className={ mergeClassNames(['bl-icon--loader'], className) }
                         width="52"
                         height="52"
                         viewBox="0 0 52 52"
                         xmlns="http://www.w3.org/2000/svg"
                         { ..._preserveRatio }>
                        { this._getTitle() }
                        <path id="blLoaderIconBackground" fill={ bgFill } d="M26 4c12.1 0 22 9.9 22 22s-9.9 22-22 22S4 38.1 4 26 13.9 4 26 4m0-4C11.6 0 0 11.6 0 26s11.6 26 26 26 26-11.6 26-26S40.4 0 26 0z" opacity=".8"/>
                        <path id="blLoaderIconForeground" fill={ fill } d="M26 0v4c12.1 0 22 9.9 22 22s-9.9 22-22 22v4c14.4 0 26-11.6 26-26S40.4 0 26 0z"/>
                    </svg>
                );
            }

            case icon.LOCATION:
                return (
                    <svg className={ mergeClassNames(['bl-icon--location'], className) }
                         width="11"
                         height="17"
                         viewBox="0 0 11 17"
                         xmlns="http://www.w3.org/2000/svg"
                         { ..._preserveRatio }>
                        { this._getTitle() }
                        <g fill={ fill } >
                            <g id="Location_Icon" fillRule="evenodd">
                                <path d="M5.5 17c-.3 0-.6-.2-.7-.5C3.2 12.6 0 7.6 0 5.2 0 2.3 2.5 0 5.5 0S11 2.3 11 5.2c0 2.4-3.2 7.3-4.8 11.3-.1.3-.4.5-.7.5zM2.2 5.1c0 1.8 1.5 3.2 3.3 3.2 1.8 0 3.3-1.4 3.3-3.2 0-1.7-1.5-3.2-3.3-3.2-1.8 0-3.3 1.4-3.3 3.2z" />
                            </g>
                        </g>
                    </svg>
                );

            case icon.NOTE:
                return (
                    <svg className={ mergeClassNames(['bl-icon--note'], className) }
                         width="28"
                         height="32"
                         viewBox="0 0 28 32"
                         xmlns="http://www.w3.org/2000/svg"
                         { ..._preserveRatio }>
                        { this._getTitle() }
                        <g fill={ fill } fillRule="evenodd" id="Note_Icon">
                            <path d="M26 32H2c-1.1045 0-2-.89456-2-2V2C0 .89456.8955 0 2 0h24c1.1055 0 2 .89456 2 2v28c0 1.07153-.85083 2-2 2zM5 7.5c0 .82912.40252 1.5.9 1.5h16.2c.49747 0 .9-.67088.9-1.5 0-.82913-.40253-1.5-.9-1.5H5.9c-.49748 0-.9.67087-.9 1.5zm0 6c0 .82912.40252 1.5.9 1.5h16.2c.49747 0 .9-.67088.9-1.5s-.40253-1.5-.9-1.5H5.9c-.49748 0-.9.67088-.9 1.5zM22.1 21c.49747 0 .9-.67087.9-1.5s-.40253-1.5-.9-1.5H5.9c-.49748 0-.9.67087-.9 1.5s.40252 1.5.9 1.5h16.2z" />
                        </g>
                    </svg>
                );

            case icon.PENDING:
                return (
                    <svg className={ mergeClassNames(['bl-icon--pending'], className) }
                         width="20"
                         height="18"
                         viewBox="0 0 20 18"
                         xmlns="http://www.w3.org/2000/svg"
                         { ..._preserveRatio }>
                        { this._getTitle() }
                        <g fill={ fill } fillRule="evenodd" id="Pending_Icon">
                            <path d="M2.6738 9.1444V9.091H.6418l3.2085-3.2086L7.0588 9.091h-2.032v.0534c0 3.4224 2.7807 6.2032 6.203 6.2032 3.4226 0 6.2034-2.7808 6.2034-6.2032 0-3.4225-2.7808-6.2032-6.2033-6.2032-2.0856 0-3.9038 1.016-5.0803 2.6203l-.909-1.016-.6952-.6952C6.1497 1.8717 8.556.5348 11.337.5348c4.7593 0 8.6095 3.8502 8.6095 8.6096 0 4.7593-3.9037 8.6096-8.663 8.6096-4.7594 0-8.6097-3.8503-8.6097-8.6096z"/>
                            <path d="M10.7487 4.8128v4.706l3.9572 2.4598.5346-.909-3.4224-2.139V4.8127"/>
                        </g>
                    </svg>
                );

            case icon.STATUS_CHANGE:
              return (
                  <svg className={ mergeClassNames(['bl-icon--status-change'], className) }
                        width="37"
                        height="34"
                        viewBox="0 0 37 34"
                        xmlns="http://www.w3.org/2000/svg"
                        { ..._preserveRatio }>
                      { this._getTitle() }
                      <g fill={ fill }>
                          <g id="StatusChange_Icon">
                              <path d="M32.3 19.2h-9.7c-2.2 0-3.9 1.7-3.9 3.9v1.6H8.1v-4c0-.6-.4-.8-.9-.4L.6 25.8c-.5.4-.5 1.1 0 1.5l6.6 5.5c.5.4.9.2.9-.4v-4h10.5V30c0 2.2 1.7 3.9 3.9 3.9h9.7c2.2 0 3.9-1.7 3.9-3.9v-6.8c.1-2.2-1.7-4-3.8-4zm.4 10.3c0 .5-.4 1-1 1H23c-.5 0-1-.4-1-1v-5.8c0-.5.4-1 1-1h8.7c.5 0 1 .4 1 1v5.8zM4.2 15H14c2.2 0 3.9-1.7 3.9-3.9V9.5h10.5v4c0 .6.4.8.9.4l6.6-5.5c.5-.4.5-1.1 0-1.5l-6.6-5.5c-.5-.4-.9-.2-.9.4v4H17.9V4.2C17.9 2 16.2.3 14 .3H4.3C2.1.3.4 2 .4 4.2V11c-.1 2.3 1.7 4 3.8 4zM3.8 4.8c0-.5.4-1 1-1h8.7c.5 0 1 .4 1 1v5.8c0 .5-.4 1-1 1H4.8c-.5 0-1-.4-1-1V4.8z"
                                    fillRule="evenodd" />
                          </g>
                      </g>
                  </svg>
              );

            default:
                return null;
        }
    }
};

export default InfoIcon;
